import { ResourceSymbol } from "utils/config/reference";

export const disableBackWrad = (page, start) => {
  return parseInt(page, 10) <= parseInt(start, 10);
};
export const disableForWard = (page, finish) => {
  return parseInt(page, 10) >= parseInt(finish, 10);
};

export const getProductNameResource = (keyProductos) => {
  switch (keyProductos) {
    case "3":
      return ResourceSymbol.avina;
    case "5":
      return ResourceSymbol.herramientas;
    case "1":
      return ResourceSymbol.matias;
    case "2":
      return ResourceSymbol.americaPodcast;
    case "4":
      return ResourceSymbol.ruzia;
    default:
      return ResourceSymbol.matias;
  }
};


  export const storyRedirect = (id, level, pageStart) => {
    if (!pageStart) return;
    const url = `/stories?id=${id}&page=${pageStart}&level=${level}&activity=null&quiz=null`;
    return url;
  };